<template>
<div  class="fff">
<div class="page_title">{{$t('Select the Device')}}</div>
<div class="page_bo_li">
<img @click="isshow=1" v-if="isshow!=1" src="@/assets/img/qnodui.png" alt="" class="system_logo">
<img @click="isshow=0" v-if="isshow==1"  src="@/assets/img/qdui.png" alt="" class="system_logo">
        Device A
    </div>
<div class="page_bo_li">
<img @click="isshow=2" v-if="isshow!=2"  src="@/assets/img/qnodui.png" alt="" class="system_logo">
<img @click="isshow=0" v-if="isshow==2"  src="@/assets/img/qdui.png" alt="" class="system_logo">

        Device B
    </div>
<div class="twoButton">
<div class="BackButton">{{$t('selectTheDevice.back')}}</div>
<div class="loginButton">{{$t('selectTheDevice.continue')}}</div>
</div>
</div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      isshow: 0,
      msg: ''
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff{width:100%;position:absolute;height:100%;background:#fff;overflow:hidden}
.page_bo_li{margin-bottom:20px;position:relative;padding:25px 0;line-height:30px;cursor:pointer;font-size:14px;color:#000927;font-weight:700}
.system_logo{float:left;width:20px;margin:5px 15px 0 20px}

</style>



// WEBPACK FOOTER //
// src/components/SelectTheDevice.vue